import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import PulseReport from "../components/PulseReport";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PulseShare() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios.get(`${API}/pulse/share/${token}`)
      .then((r) => setData(r.data))
      .catch((e) => setError(e?.response?.data?.detail || "Share link is invalid"));
  }, [token]);

  if (error) {
    return (
      <div className="min-h-screen geo-bg grid place-items-center p-6">
        <div className="hifz-card max-w-md text-center" data-testid="pulse-share-error">
          <h1 className="font-display font-semibold text-xl text-forest-700">Link unavailable</h1>
          <p className="mt-2 text-sm text-muted-foreground">{error}</p>
          <Link to="/" className="mt-5 btn-primary inline-flex" data-testid="back-home">Go to Hifz with Hikmah</Link>
        </div>
      </div>
    );
  }

  if (!data) {
    return <div className="min-h-screen geo-bg grid place-items-center text-muted-foreground" data-testid="pulse-share-loading">Loading…</div>;
  }

  return (
    <div className="min-h-screen geo-bg">
      <header className="container-page py-6 flex items-center justify-between border-b border-sand-300">
        <Link to="/" className="flex items-center gap-2.5" data-testid="share-brand">
          <img src="/Hikma-Verse-Logo.png" alt="Hikmah Verses" className="h-10 w-10 rounded-xl object-cover" />
          <div>
            <div className="font-display font-semibold text-forest-700 leading-tight">Hifz with Hikmah</div>
            <div className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground">HikmahVerses</div>
          </div>
        </Link>
        <div className="text-xs text-muted-foreground hidden sm:block">Hifz Pulse · weekly parent report</div>
      </header>

      <div className="container-page py-10 max-w-5xl">
        <PulseReport pulse={data.pulse} />

        <div className="mt-10 hifz-card text-center" data-testid="share-cta">
          <div className="text-xs uppercase tracking-[0.22em] text-gold-600 font-semibold">For parents</div>
          <h2 className="mt-2 font-display font-semibold text-2xl text-forest-700">
            Want to memorize the Qur'an with hikmah, too?
          </h2>
          <p className="mt-2 text-sm text-foreground/70 max-w-xl mx-auto">
            HikmahVerses helps the whole family — from cradle to grave — understand and live the Qur'an.
          </p>
          <Link to="/" className="mt-5 inline-flex btn-primary" data-testid="share-cta-explore">
            Explore the program
          </Link>
          <p className="mt-4 text-[11px] text-muted-foreground">This link expires on {new Date(data.expires_at).toLocaleDateString()}.</p>
        </div>
      </div>
    </div>
  );
}
